<template>
  <div class="container" ref="container">
    <div class="table-container" id="tmp" ref="c3tcontainer"></div>
  </div>
</template>

<script>
/**
 * C3-Tableのラッパーコンポーネント
 *
 * C3Tableインスタンスを内包し、渡されたデータを描画します。
 */
export default {
  props: {
    rows: Array,
    columns: Array,
  },
  data: () => {
    return {
      c3table: undefined,
    }
  },
  methods: {
    init() {
      if (!this.columns || this.columns.length === 0) {
        return
      }

      // this.columnsはVue管理のObserverであり、C3Tableにそのまま渡すとうまく
      // 動かないので変換する。
      const columns = this.columns.map(c => ({
        colName: c.colName,
        headerText: c.headerText,
        type: c.type,
      }))

      // eslint-disable-next-line no-undef
      this.c3table = new C3Table({
        container: this.$refs.c3tcontainer,
        columns,
        selectable: false,
      })

      this.c3table.build()
    },
  },
  watch: {
    rows() {
      if (!this.c3table) {
        // not initialized
        return
      }
      this.c3table.setSize(
        this.$refs.container.clientWidth,
        this.$refs.container.clientHeight,
      )
      this.c3table.clearData()
      this.c3table.load(this.rows)
    },
    columns() {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
